import { LEVELS } from '../../constants/levels.js';
import { N } from '../../constants/fonts.js';
import { getLevelName } from '../../config/levelConfig.js';

export function LB({ level }) {
  const l = LEVELS[level] || LEVELS[3];
  const levelName = getLevelName(level);
  return (
    <span style={{
      display:"inline-block",
      padding:"4px 12px",
      borderRadius:10,
      fontSize:12,
      fontFamily:N,
      fontWeight:700,
      background:`${l.color}18`,
      color:l.color,
      border:`2px solid ${l.color}33`
    }}>{levelName}</span>
  );
}
